/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Who caused a delivery. Mirrors the database enum company_webhook_delivery_trigger: `system` is a shipment event, `customer` a redelivery from the Dashboard, `ops` a redelivery by FreightSimple.
 * @export
 */
export const WebhookDeliveryTrigger = {
    System: 'system',
    Customer: 'customer',
    Ops: 'ops'
} as const;
export type WebhookDeliveryTrigger = typeof WebhookDeliveryTrigger[keyof typeof WebhookDeliveryTrigger];


export function instanceOfWebhookDeliveryTrigger(value: any): boolean {
    for (const key in WebhookDeliveryTrigger) {
        if (Object.prototype.hasOwnProperty.call(WebhookDeliveryTrigger, key)) {
            if (WebhookDeliveryTrigger[key as keyof typeof WebhookDeliveryTrigger] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WebhookDeliveryTriggerFromJSON(json: any): WebhookDeliveryTrigger {
    return WebhookDeliveryTriggerFromJSONTyped(json, false);
}

export function WebhookDeliveryTriggerFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebhookDeliveryTrigger {
    return json as WebhookDeliveryTrigger;
}

export function WebhookDeliveryTriggerToJSON(value?: WebhookDeliveryTrigger | null): any {
    return value as any;
}

export function WebhookDeliveryTriggerToJSONTyped(value: any, ignoreDiscriminator: boolean): WebhookDeliveryTrigger {
    return value as WebhookDeliveryTrigger;
}

